import React, { useEffect } from "react";
import { calFinalPrice } from "../../../../redux/action/buyerAction";
import { handleCalculateFinalPrice } from "../../../../redux/slice/buyerSlice";
import Shimmer from "../../../common/shimmer/Shimmer";
import { ACCOUNT } from "../../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import useTranslationHook from "../../../hooks/useTranslationHook";
import { formatPrice } from "../../../../helpers";

export default function PriceCalculator({ property_id }) {
    const lang = useSelector((state) => state.translation.lang);
    const { t } = useTranslationHook();

    const dispatch = useDispatch();
    const account = useSelector((state) => state.profile.account);
    const buyerPriceCalculator = useSelector(
        (state) => state.buyer.buyerPriceCalculator
    );
    const { property_setting } = useSelector(
        (state) => state.seller.property.propertyData
    );

    const calculateFinalPrice = () => {
        dispatch(calFinalPrice({ property_id: property_id }, t));
    };

    const serviceFeePercentage = Number(property_setting?.service_fee) || 0;
    const serviceFeeAmount = serviceFeePercentage
        ? (serviceFeePercentage / 100) *
          Number(buyerPriceCalculator.current_bid || 0)
        : 0;
    const totalWithServiceFee =
        buyerPriceCalculator.total_price == null
            ? null
            : Number(buyerPriceCalculator.total_price) + serviceFeeAmount;

    const closePriceBreakdown = () =>
        dispatch(handleCalculateFinalPrice({ show: false }));

    useEffect(() => {
        return () => {
            dispatch(handleCalculateFinalPrice({ reset: true }));
        };
    }, []);
    return (
        <>
            {!buyerPriceCalculator.show ? (
                <div className="price-calculator">
                    <h6>{t("Final price calculation")}</h6>
                    <button
                        className="btn btn-white btn-sm btn-full"
                        onClick={() => {
                            dispatch(handleCalculateFinalPrice({ show: true }));
                            calculateFinalPrice();
                        }}
                    >
                        {t("Calculate Final Price")}
                    </button>
                </div>
            ) : (
                <></>
            )}

            {/* Phones only (<768px): a bottom sheet replaces the inline
                accordion below for the buyer breakdown. */}
            {buyerPriceCalculator.show && ACCOUNT.Buyer === account && (
                <div
                    className="price-breakdown-sheet d-md-none"
                    dir={lang === "ar" ? "rtl" : "ltr"}
                >
                    <button
                        type="button"
                        className="price-breakdown-backdrop"
                        onClick={closePriceBreakdown}
                        aria-label={t("Close")}
                    />
                    <div className="price-breakdown-panel">
                        <div className="price-breakdown-header">
                            <h6>{t("Price Breakdown")}</h6>
                            <button
                                type="button"
                                className="price-breakdown-close"
                                onClick={closePriceBreakdown}
                                aria-label={t("Close")}
                            >
                                &times;
                            </button>
                        </div>

                        {buyerPriceCalculator.dataLoading ? (
                            <Shimmer
                                type="rectangle"
                                width="100%"
                                height="20vh"
                                borderRadius="5%"
                            />
                        ) : (
                            <>
                                <div className="price-breakdown-row">
                                    <span>{t("Winning Bid Amount")}</span>
                                    <strong>
                                        {t("Amount", {
                                            amount: formatPrice(
                                                buyerPriceCalculator.current_bid,
                                                lang
                                            ),
                                        })}
                                    </strong>
                                </div>
                                {serviceFeePercentage ? (
                                    <div className="price-breakdown-row">
                                        <span>
                                            {t("ADREC transfer fee", {
                                                percent: serviceFeePercentage,
                                            })}
                                        </span>
                                        <strong>
                                            {t("Amount", {
                                                amount: formatPrice(
                                                    serviceFeeAmount,
                                                    lang
                                                ),
                                            })}
                                        </strong>
                                    </div>
                                ) : null}
                                <div className="price-breakdown-row total">
                                    <span>{t("Total Amount")}</span>
                                    <strong>
                                        {totalWithServiceFee == null
                                            ? t("NA")
                                            : t("Amount", {
                                                  amount: formatPrice(
                                                      totalWithServiceFee,
                                                      lang
                                                  ),
                                              })}
                                    </strong>
                                </div>
                                {serviceFeePercentage ? (
                                    <div className="price-breakdown-note">
                                        <i className="fa-solid fa-circle-info"></i>
                                        <span>
                                            {t("ADREC transfer fee note", {
                                                percent: serviceFeePercentage,
                                            })}
                                        </span>
                                    </div>
                                ) : null}
                            </>
                        )}

                        <button
                            type="button"
                            className="btn price-breakdown-close-btn"
                            onClick={closePriceBreakdown}
                        >
                            {t("Close")}
                        </button>
                    </div>
                </div>
            )}

            {buyerPriceCalculator.show ? (
                <div className="price-calculator d-none d-md-block">
                    <div className="accordion " id="accordionExample">
                        <div className="accordion-item">
                            <h6 className="accordion-header" id="headingOne">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-controls="collapseOne"
                                >
                                    {t("Final price calculation")}
                                </button>
                            </h6>
                            <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    {buyerPriceCalculator.dataLoading ? (
                                        <Shimmer
                                            type="rectangle"
                                            width="100%"
                                            height="20vh"
                                            margin-top="0"
                                            borderRadius="5%"
                                        ></Shimmer>
                                    ) : (
                                        <>
                                            {ACCOUNT.Buyer === account ? (
                                                <ul>
                                                    <li>
                                                        {t("Bid Price")}
                                                        {buyerPriceCalculator.current_bid ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {t("Amount", {
                                                                    amount: formatPrice(
                                                                        buyerPriceCalculator.current_bid,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    {serviceFeePercentage ? (
                                                        <li>
                                                            {t("Service Fee")}
                                                            <span>
                                                                {t("Amount", {
                                                                    amount: formatPrice(
                                                                        serviceFeeAmount,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        </li>
                                                    ) : null}
                                                    {/* Buyer premium amount hidden per request - keep code, do not remove
                                                    {Number(
                                                        buyerPriceCalculator.buyers_premium
                                                    ) ? (
                                                        <li>
                                                            {t(
                                                                "Buyer premium amount"
                                                            )}
                                                            <span>
                                                                {" "}
                                                                {buyerPriceCalculator.buyers_premium ===
                                                                null ? (
                                                                    <span>
                                                                        {t(
                                                                            "NA"
                                                                        )}
                                                                    </span>
                                                                ) : (
                                                                    <>
                                                                        <em className="dirham">
                                                                            D
                                                                        </em>{" "}
                                                                        {t(
                                                                            "Amount",
                                                                            {
                                                                                amount: formatNumberByLocale(
                                                                                    buyerPriceCalculator.buyers_premium,
                                                                                    lang
                                                                                ),
                                                                            }
                                                                        )}
                                                                    </>
                                                                )}
                                                            </span>
                                                        </li>
                                                    ) : null}
                                                    */}
                                                    {/* Platform fees hidden per request - keep code, do not remove
                                                    {Number(
                                                        buyerPriceCalculator.platform_fees
                                                    ) ? (
                                                        <li>
                                                            {t("Platform fees")}
                                                            <span>
                                                                {buyerPriceCalculator.platform_fees ===
                                                                null ? (
                                                                    <span>
                                                                        {t(
                                                                            "NA"
                                                                        )}
                                                                    </span>
                                                                ) : (
                                                                    <span>
                                                                        <em className="dirham">
                                                                            D
                                                                        </em>{" "}
                                                                        {t(
                                                                            "Amount",
                                                                            {
                                                                                amount: formatNumberByLocale(
                                                                                    buyerPriceCalculator.platform_fees,
                                                                                    lang
                                                                                ),
                                                                            }
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </li>
                                                    ) : null}
                                                    */}
                                                    {/* VAT hidden per request - keep code, do not remove
                                                    {Number(
                                                        buyerPriceCalculator.taxes
                                                    ) ? (
                                                        <li>
                                                            {t("VAT")}
                                                            {buyerPriceCalculator.taxes ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <em className="dirham">
                                                                        D
                                                                    </em>{" "}
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatNumberByLocale(
                                                                                buyerPriceCalculator.taxes,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </li>
                                                    ) : null}
                                                    */}
                                                    <li>
                                                        {t("Total")}
                                                        {totalWithServiceFee ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {t("Amount", {
                                                                    amount: formatPrice(
                                                                        totalWithServiceFee,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                </ul>
                                            ) : (
                                                <ul>
                                                    <li>
                                                        {t(
                                                            "Auction commission amount"
                                                        )}
                                                        <span>
                                                            {buyerPriceCalculator.commission_amount ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatPrice(
                                                                                buyerPriceCalculator.commission_amount,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </li>
                                                    {Number(
                                                        buyerPriceCalculator.taxes
                                                    ) ? (
                                                        <li>
                                                            {t(
                                                                "Commission VAT"
                                                            )}
                                                            {buyerPriceCalculator.taxes ===
                                                            null ? (
                                                                <span>
                                                                    {t("NA")}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {t(
                                                                        "Amount",
                                                                        {
                                                                            amount: formatPrice(
                                                                                buyerPriceCalculator.taxes,
                                                                                lang
                                                                            ),
                                                                        }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </li>
                                                    ) : null}
                                                    <li>
                                                        {t("Hammer Price")}
                                                        {buyerPriceCalculator.current_bid ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {t("Amount", {
                                                                    amount: formatPrice(
                                                                        buyerPriceCalculator.current_bid,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t("Total")}
                                                        {buyerPriceCalculator.total_price ===
                                                        null ? (
                                                            <span>
                                                                {t("NA")}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {t("Amount", {
                                                                    amount: formatPrice(
                                                                        buyerPriceCalculator.total_price,
                                                                        lang
                                                                    ),
                                                                })}
                                                            </span>
                                                        )}
                                                    </li>
                                                </ul>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        className="btn btn-white btn-sm btn-full"
                        onClick={calculateFinalPrice}
                    >
                        {t("Recalculate Final Price")}
                    </button>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
